import { RenderSelectInput, RenderTextInput } from "app/common/renderInput";
import {
  airlinesCommission,
  getAirlinesCommission,
} from "app/services/SearchService";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { Form, Row, Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { NotificationManager } from "react-notifications";
import * as yup from "yup";

const commissionStateSchema = yup.object().shape({
  flightCommStatus: yup.string().required("CommissionStatus Type is required"),
  commissionType: yup.string().required("Commission Type is required"),
  domesticCommissionType: yup
    .string()
    .required("Domestic Markup Mode is required"),
  domesticCommissionValue: yup
    .number()
    // .positive("Domestic Markup must be a positive value")
    .required("Domestic Markup is required"),
  internationalCommissionType: yup
    .string()
    .required("International Markup Mode is required"),
  internationalCommissionValue: yup
    .number()
    // .positive("International Markup must be a positive value")
    .required("International Markup  is required"),
});
function MarkUpCom({ show, handleClose, editRow, loadAirlines, editId }) {
  const [isShow, setIsShow] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const commissionState = {
    id: 0,
    flightCarrierId: 0,
    commissionType: "Negative",
    domesticCommissionType: "Percentage",
    domesticCommissionValue: 0,
    internationalCommissionType: "Percentage",
    internationalCommissionValue: 0,
    flightCommStatus: true,
  };
  const [state, setState] = useState(commissionState);
  const commissionModeOptions = [
    // { value: "Positive", label: "Positive" },
    { value: "Negative", label: "Negative" },
  ];
  const statusCom = [
    { value: true, label: "Active" },
    { value: false, label: "Inactive" },
  ];
  const markupModeOptions = [
    // { value: "Static", label: "Static" },
    { value: "Percentage", label: "Percentage" },
  ];
  useEffect(() => {
    const fetchData = async () => {
      if (editId) {
        setIsLoading(true);
        const response = await getAirlinesCommission(editId);
        if (response.data != null) {
          setState(response.data);
          setIsAdd(true);
          setIsLoading(false);
        } else {
          setIsAdd(false);
          setIsLoading(false);
        }
      }
    };
    fetchData();
  }, [editId]);

  const handleSubmitCommission = async (values) => {
    debugger;
    setIsShow(true);
    const response = await airlinesCommission({
      id: editId,
      flightCarrierId: editId,
      commissionType: values.commissionType,
      domesticCommissionType: values.domesticCommissionType,
      domesticCommissionValue: values.domesticCommissionValue,
      internationalCommissionType: values.internationalCommissionType,
      internationalCommissionValue: values.internationalCommissionValue,
      flightCommStatus: values.flightCommStatus,
    });
    console.log(response);
    try {
      if (response.status == "Success") {
        {
          isAdd == true
            ? NotificationManager.success(
                "Airlines Commission Update successfully"
              )
            : NotificationManager.success(
                "Airlines Commission Add successfully"
              );
        }
        loadAirlines();
        handleClose();
        setIsShow(false);
      } else {
        setIsShow(false);
        loadAirlines();
        NotificationManager.success("Something went wrong");

        handleClose();
      }
    } catch (error) {
      setIsShow(false);
      loadAirlines();
      NotificationManager.error("something went to be wrong");
      handleClose();
      console.log(error);
      throw error;
    }
  };

  useEffect(() => {
    setState(commissionState);
    // editRow;
  }, [editRow]);

  return (
    <>
      <Formik
        initialValues={state}
        validationSchema={commissionStateSchema}
        enableReinitialize={true}
        onSubmit={handleSubmitCommission}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          isSubmitting,
        }) => (
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                {isAdd == true
                  ? "Update Airline Commission"
                  : "Add Airline Commission"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form onSubmit={handleSubmit} className="p-3">
                <Form.Group>
                  <RenderSelectInput
                    disabled={isLoading == true ? true : false}
                    type="text"
                    display="Commission Status"
                    name="flightCommStatus"
                    items={statusCom}
                    value={values?.flightCommStatus}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors?.flightCommStatus}
                    touched={touched?.flightCommStatus}
                    required
                  ></RenderSelectInput>
                </Form.Group>

                <Form.Group>
                  <RenderSelectInput
                    disabled={isLoading == true ? true : false}
                    type="text"
                    display="Commission Mode"
                    name="commissionType"
                    items={commissionModeOptions}
                    value={values?.commissionType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors?.commissionType}
                    touched={touched?.commissionType}
                    required
                  ></RenderSelectInput>
                </Form.Group>
                <Form.Group>
                  <RenderSelectInput
                    disabled={isLoading == true ? true : false}
                    type="text"
                    display="Domestic Markup Mode"
                    name="domesticCommissionType"
                    items={markupModeOptions}
                    value={values?.domesticCommissionType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors?.domesticCommissionType}
                    touched={touched?.domesticCommissionType}
                    required
                  ></RenderSelectInput>
                </Form.Group>
                <Form.Group className="mb-3">
                  <RenderTextInput
                    disabled={isLoading == true ? true : false}
                    type="number"
                    display="Domestic Markup"
                    placeholder="Enter Domestic Markup"
                    name="domesticCommissionValue"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    error={errors.domesticCommissionValue}
                    value={values?.domesticCommissionValue}
                    touched={touched.domesticCommissionValue}
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <RenderSelectInput
                    disabled={isLoading == true ? true : false}
                    type="text"
                    display="International Markup Mode"
                    name="internationalCommissionType"
                    items={markupModeOptions}
                    value={values?.internationalCommissionType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors?.internationalCommissionType}
                    touched={touched?.internationalCommissionType}
                    required
                  ></RenderSelectInput>
                </Form.Group>
                <Form.Group className="mb-3">
                  <RenderTextInput
                    disabled={isLoading == true ? true : false}
                    type="number"
                    display="International Markup"
                    placeholder="Enter International Markup"
                    name="internationalCommissionValue"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    autoComplete="off"
                    error={errors.internationalCommissionValue}
                    value={values?.internationalCommissionValue}
                    touched={touched.internationalCommissionValue}
                    required
                  />
                </Form.Group>
                <Row>
                  <div className="m-auto text-center">
                    {isShow ? (
                      <Button variant="primary" size="md" disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          style={{ marginRight: "10px" }}
                        />
                        {isAdd == true ? "Updating..." : "Adding..."}
                      </Button>
                    ) : isLoading == true ? (
                      <Button variant="primary" size="md" disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          style={{ marginRight: "10px" }}
                        />
                        Loading...
                      </Button>
                    ) : (
                      <Button variant="primary" size="md" type="submit">
                        {isAdd == true ? "Update Commission" : "Add Commission"}
                      </Button>
                    )}
                  </div>
                </Row>
              </form>
            </Modal.Body>
          </Modal>
        )}
      </Formik>
    </>
  );
}

export default MarkUpCom;
